<template>
  <div ref="sectionReservation">
    <AlertMessage
      v-if="alert.message != ''"
      :type="alert?.type"
      :title="alert?.title"
      :message="alert?.message"
    />

    <!-- <pre class="my-5 p-5">{{ $page || "???" }}</pre> -->

    <form @submit.prevent="formSubmit">
      <fieldset class="px-5 my-3">
        <!-- <legend class="fs-5 fw-bold">Selectionnez une Session de Formation</legend> -->
        <FormSelect
          v-model="form.formation_id"
          @update:modelValue="updateFormation"
          label="Formation recherchée"
          id="formation_id"
          :options="formations"
          :errors="errors.formation_id"
          :disabledText="'Selectionnez une Formation'"
        />

        <SessionsList
          :sessions="availableSessions"
          :sessionId="currentSessionId"
          :formationId="form.formation_id"
          @update="updateSessionId"
          :errors="errors?.session_id"
          :isLoading="sessionsLoading"
        />
      </fieldset>

      <fieldset class="px-5 my-3">
        <legend class="fs-5 fw-bold">Coordonnées Client</legend>
        <FormInput
          v-model="form.last_name"
          :label="__('last_name')"
          id="customer_last_name"
          :errors="errors?.last_name"
        />

        <FormInput
          v-model="form.first_name"
          :label="__('first_name')"
          id="customer_first_name"
          :errors="errors?.first_name"
        />

        <FormInput
          type="email"
          v-model="form.email"
          :label="__('email')"
          id="customer_email"
          :errors="errors?.email"
        />

        <FormInput
          v-model="form.phone"
          :label="__('phone')"
          id="customer_phone"
          :errors="errors?.phone"
        />

        <div class="row mb-3">
          <label class="col-sm-4 col-xl-3 col-form-label-sm text-sm-end">
            Vous êtes
          </label>
          <div class="col-sm-8 col-xl-9">
            <FormRadioGroup
              :options="reservation_types"
              v-model:checked="form.reservation_type"
              id="reservation_type"
            />
          </div>
        </div>

        <FormInput
          v-show="form.reservation_type == 'company'"
          v-model="form.company_name"
          :label="__('company_name')"
          id="company_name"
          :errors="errors?.company_name"
        />

        <div class="form-check offset-sm-4 offset-col-xl-3 mb-3">
          <FormCheckbox
            id="is_not_student"
            v-model:checked="form.is_not_student"
            class="form-check-input"
          />
          <label class="form-check-label" for="is_not_student">
            Je remplis le formulaire pour inscrire d'autres personnes ( société
            )
          </label>
          <div v-if="errors?.is_not_student" class="invalid-feedback">
            {{ errors?.is_not_student }}
          </div>
        </div>
      </fieldset>

      <fieldset v-show="displayStudentsTable">
        <legend class="fs-5 fw-bold">Coordonnées des Apprenants</legend>

        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Nom</th>
                <th>Prénom</th>
                <th>Email</th>
                <th>Téléphone</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(student, index) in form.students"
                :key="'row_student_' + index"
              >
                <td>{{ index }}</td>
                <td>
                  <FormInput
                    v-model="student.last_name"
                    :key="`student.${index}.last_name`"
                    :errors="errors[`students.${index}.last_name`]"
                    placeholder="last_name"
                    :id="`student.${index}.last_name`"
                  />
                </td>
                <td>
                  <FormInput
                    v-model="student.first_name"
                    :key="`student.${index}.first_name`"
                    placeholder="first_name"
                    :id="`student.${index}.first_name`"
                    :errors="errors[`students.${index}.first_name`]"
                  />
                </td>
                <td>
                  <FormInput
                    type="email"
                    v-model="student.email"
                    :key="`student.${index}.email`"
                    placeholder="email"
                    :id="`student.${index}.email`"
                    :errors="errors[`students.${index}.email`]"
                  />
                </td>
                <td>
                  <FormInput
                    v-model="student.phone"
                    :key="`student.${index}.phone`"
                    placeholder="phone"
                    :id="`student.${index}.phone`"
                    :errors="errors[`students.${index}.phone`]"
                  />
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4">
                  <button
                    class="btn btn-primary me-auto"
                    @click.prevent="addStudent"
                  >
                    Ajouter
                  </button>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </fieldset>

      <div class="actions d-flex justify-content-around my-3 px-3">
        <button
          type="reset"
          @click.prevent="formReset"
          class="btn btn-lg btn-secondary"
        >
          Reset
        </button>
        <button
          type="submit"
          class="btn btn-lg btn-primary"
          :disabled="isLoading"
        >
          <div class="spinner-border text-info" role="status" v-if="isLoading">
            <span class="visually-hidden">Loading...</span>
          </div>
          Sauvegarder
        </button>
      </div>
    </form>
    <div class="row my-3">
      <PreDebug class="col-sm-6" title="form">{{ form }}</PreDebug>
      <PreDebug class="col-sm-6" title="availableSessions">{{
        availableSessions
      }}</PreDebug>
      <PreDebug class="col-sm-6" title="form.students">{{
        form.students
      }}</PreDebug>
      <PreDebug class="col-sm-6" title="errors">{{ errors }}</PreDebug>
    </div>
  </div>
</template>
<script>
import PreDebug from "@/Components/PreDebug.vue";
import FormInput from "@/Components/Form/Input.vue";
import FormSelect from "@/Components/Form/Select.vue";
import FormCheckbox from "@/Components/Form/Checkbox.vue";
import FormRadioGroup from "@/Components/Form/RadioGroup.vue";

import SessionsList from "@/Components/Front/Reservations/SessionsList.vue";
import AlertMessage from "@/Components/Front/Reservations/AlertMessage.vue";

const emptyForm = {
  last_name: "",
  first_name: "",
  email: "",
  phone: "",
  company_name: "",
  // formation_id: "this.formation?.id ||" null,
  formation_id: null,
  session_id: "",
  is_not_student: false,
  reservation_type: "particular",
  students: [],
};

export default {
  components: {
    FormInput,
    FormSelect,
    FormCheckbox,
    PreDebug,
    FormRadioGroup,
    SessionsList,
    AlertMessage,
  },

  props: {
    formations: {
      type: Array,
      required: true,
    },
    formation: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      reservation_types: [
        { label: "une Société", value: "company" },
        { label: "un particulier", value: "particular" },
        // { label: "organisme de formation", value: "training-organization" },
        // { label: "auto-finançé", value: "self-funded" },
      ],
      currentSessionId: null,

      availableSessions: [],

      form: emptyForm,
      currentSessionId: null,
      displayStudentsTable: false,

      sessionsLoading: false,
      isLoading: false,

      errors: [],

      alert: {
        message: "",
        title: "",
        info: "",
      },
    };
  },

  computed: {
    // displayStudentsTable() {
    //   return this.form.is_not_student === true;
    // },
  },

  mounted() {
    if (this.formation?.id > 0) {
      this.form.formation_id = this.formation.id;
      this.updateFormation(this.formation.id);
    }
  },

  watch: {
    form: {
      handler(newValues, oldValues) {
        console.log("newValues" + newValues, "oldValues" + oldValues);
        for (let field in newValues) {
          if (this.form[field] !== oldValues[field]) {
            this.errors[field] = "";
          }
        }
      },
      deep: true,
    },
    "form.is_not_student": {
      handler() {
        if (this.form.is_not_student === false) {
          this.displayStudentsTable = false;
        } else {
          this.displayStudentsTable = true;
        }
        if (
          this.form.is_not_student == true &&
          this.form.students.length == 0
        ) {
          this.addStudent();
        }
      },
      immediate: true,
      deep: true,
    },

    "form.session_id": {
      handler() {
        this.errors["session_id"] = null;
        this.currentSessionId = this.form.session_id;
      },
      deep: true,
    },
  },
  methods: {
    addStudent() {
      this.form.students.push({
        last_name: "",
        first_name: "",
        email: "",
        phone: "",
      });
    },
    formReset() {
      this.alertReset();
      this.form = Object.assign({}, emptyForm);
    },

    formSubmit() {
      this.alertReset();
      Object.keys(this.errors).forEach((key) => delete this.errors[key]);
      if (this.isLoading === true) {
        return false;
      }
      if (this.form.formation_id === null) {
        alert("Veuillez selectionner une formation");
        return false;
      }
      // if (this.form.session_id === null) {
      //   alert("Veuillez selectionner une session de formation");
      //   return false;
      // }

      let payloadData = Object.assign({}, this.form);
      console.log("payloadData.is_not_student", payloadData?.is_not_student);
      if (payloadData?.is_not_student === false) {
        delete payloadData["students"];
      }
      this.isLoading = true;
      axios({
        method: "POST",
        url: "reservations",
        data: payloadData,
      })
        .then(({ data }) => {
          console.log(data);

          this.formReset();

          this.alert = {
            type: "success",
            title: "Succès",
            message:
              data?.message || "Votre reservation a bien été enregistrée",
          };
        })
        .catch((error) => {
          console.error("axios Error", error);

          // Unprocessable Entity - erreur de validation
          if (error.response.status == 422) {
            this.errors = error.response.data.errors;
            this.alertFill({
              type: "danger",
              title: "Erreur",
              message: "Veuillez corriger les champs suivants",
            });
          } else {
            // 503 par exemple
            this.alertFill({
              type: "danger",
              title: "Erreur",
              message: error,
            });
          }
        })
        .finally(() => {
          this.isLoading = false;

          var top = this.$refs.sectionReservation.offsetTop;
          window.scrollTo(0, top);
        });
    },

    updateSessionId(sessionId) {
      console.log("updateSessionId", sessionId);
      this.form.session_id = sessionId;
    },

    async updateFormation(formationId) {
      console.log("updateFormation reservations formationId", formationId);

      // on charge les sessions dispo pour la formation correspondante
      this.sessionsLoading = true;
      this.form.session_id = null;
      await axios({
        method: "GET",
        url: "api/reservations/" + formationId,
      })
        .then(({ data }) => {
          // console.log(data);

          this.availableSessions = data?.sessions || [];

          if (
            this.availableSessions.length &&
            this.availableSessions.length === 1
          ) {
            this.form.session_id = this.availableSessions[0].id;
          }
        })
        .catch((error) => {
          console.error("axios Error", error);
        })
        .finally(() => {
          this.sessionsLoading = false;
        });
    },

    alertReset() {
      this.alert = {
        title: "",
        message: "",
        type: "info",
      };
    },

    alertFill({ type, title, message }) {
      this.alert = Object.assign({}, { type, title, message: message });
    },
  },
};
</script>
